export const getLuckSheetData = (typePayIn?: boolean) => {
	const finalXlsValue: any = window;
	finalXlsValue?.luckysheet.exitEditMode();
	const finalData = finalXlsValue?.luckysheet?.transToCellData?.(
		finalXlsValue?.luckysheet.getSheetData()
	);
	const expectedArray = finalData?.reduce((acc: any, curr: any) => {
		if (!acc[curr.r]) {
			acc[curr.r] = [];
		}
		if (typePayIn) {
			if (curr.v.v || curr.v.v === 0) {
				acc[curr.r][curr.c] = curr.v.m?.toString();
			} else {
				if (acc[0][curr.c] === 'Fund Transfer Amount' && acc[curr.r]?.length) {
					acc[curr.r][curr.c] = '0';
				}
			}
			return acc;
		} else {
			if (curr.v.v) {
				acc[curr.r][curr.c] = curr.v.m?.toString();
			} else {
				if (acc[0][curr.c] === 'Fund Transfer Amount' && acc[curr.r]?.length) {
					acc[curr.r][curr.c] = '0';
				}
			}
			return acc;
		}
	}, []);

	const headers = expectedArray[0];
	const rows = expectedArray.filter(
		(item: any, index: number) => index !== 0 && item?.length
	);

	/**
	 * `rows` drops the header AND every empty row, so `rows[i]` is NOT sheet row
	 * i + 1 — a blank line anywhere above shifts it. Validation that wants to
	 * paint the offending cell has to address the sheet, so hand back the real
	 * sheet row for each entry rather than let each caller guess at the offset.
	 */
	const rowIndices = expectedArray.reduce(
		(acc: number[], item: any, index: number) => {
			if (index !== 0 && item?.length) acc.push(index);
			return acc;
		},
		[]
	);

	return {
		headers,
		rows,
		rowIndices,
		expectedArray,
	};
};

/* ---------------------------------------------------------------------------
 * Marking the cells a validation rejected
 *
 * A toast naming a row and a field ("valid Dollar Amount in row 3") still leaves
 * the reader counting columns across a wide pasted grid to find the cell it
 * means. These paint the cell itself, so the message and the sheet agree.
 * ------------------------------------------------------------------------ */

/* Light enough to read black text through, distinct from luckysheet's own
   selection tint, and the same red the rest of sv2 uses for a bad value. */
const CAPTABLE_BAD_BG = '#ffd7d7';

/** Cells painted by the last highlightCaptableCells(), so they can be cleared. */
let markedCells: { r: number; c: number }[] = [];

/**
 * Clear whatever the previous validation painted. Only the cells this module
 * itself marked are touched — a background the USER set on their own paste is
 * theirs, and blanket-clearing the sheet would silently discard it.
 */
export const clearCaptableHighlight = () => {
	const ls = (window as any)?.luckysheet;
	if (!ls?.setCellFormat) {
		markedCells = [];
		return;
	}
	markedCells.forEach(({ r, c }) => {
		try {
			ls.setCellFormat(r, c, 'bg', null);
		} catch {
			/* the sheet was torn down between validations — nothing to clear */
		}
	});
	markedCells = [];
};

/**
 * Paint each offending cell light red. Always clears the previous marks first,
 * so correcting one cell and re-submitting does not leave the old ones red and
 * the reader hunting for an error that is already fixed.
 */
export const highlightCaptableCells = (
	cells: { r: number; c: number }[] = []
) => {
	clearCaptableHighlight();
	const ls = (window as any)?.luckysheet;
	if (!ls?.setCellFormat) return;
	cells.forEach(({ r, c }) => {
		if (r == null || c == null || c < 0) return;
		try {
			ls.setCellFormat(r, c, 'bg', CAPTABLE_BAD_BG);
			markedCells.push({ r, c });
		} catch {
			/* out of range after an edit — skip it rather than abort the rest */
		}
	});
};


export const deepCompareLucksheetData = (
	firstDataSet: any,
	secondDataSet: any
) => {
	if (
		firstDataSet.headers &&
		firstDataSet.rows &&
		firstDataSet.expectedArray &&
		secondDataSet.headers &&
		secondDataSet.rows &&
		secondDataSet.expectedArray
	) {
		return (
			JSON.stringify(firstDataSet.headers) ===
				JSON.stringify(secondDataSet.headers) &&
			JSON.stringify(firstDataSet.rows) ===
				JSON.stringify(secondDataSet.rows) &&
			JSON.stringify(firstDataSet.expectedArray) ===
				JSON.stringify(secondDataSet.expectedArray)
		);
	}
	return false;
};
